import { EUserEditorAccessLevel } from '__generated__/globalTypes';
import { useContext } from 'react';
import { CtxGuideAdmin } from 'session/ctxGuideAdmin';
import { GlobalContext } from 'session/state/context';
import { useLocalStorage } from 'usehooks-ts';

export const useAccess = () => {
    const globalContext = useContext(GlobalContext);
    const [isAdmin] = useLocalStorage('admin', false);
    const currentUser = globalContext.state.loggedUser;

    return {
        isExperimental: currentUser?.userAccessLevel === EUserEditorAccessLevel.FULL,
        isAdmin,
        allowMetadata:
            currentUser.userId === 'visit-oslo' ||
            currentUser.userId === 'winter-oslo' ||
            currentUser.userId === 'nova' ||
            currentUser.userId === 'oslo-design-fair',
        allowProgramBooking:
            currentUser?.userId === 'lukas' || currentUser?.userId === 'mapheim-demo'
    };
};

export const useAccessGuide = () => {
    const access = useAccess();
    const ctxGuide = useContext(CtxGuideAdmin);

    return {
        isWelcomeApp: ctxGuide.guide.guideType === 'guide',
        isMapV2: ctxGuide.guide.guideType === 'map',
        isOldGuide: ctxGuide.guide.guideType === 'old_guide',
        isAdmin: access.isAdmin,
        allowProgramBooking: access.allowProgramBooking
    };
};
